// extracted by mini-css-extract-plugin
module.exports = {"headline":"headline-m__headline__3jOQi","dark":"headline-m__dark__30lii","light":"headline-m__light__3uk5Q"};